import axios from 'axios';
import auth from '@/utils/auth';

import {
  GET_STATEMENTS,
  GET_STATEMENTS_ERROR,
  GET_STATEMENTS_SUCCESS,

  GET_STATEMENT,
  GET_STATEMENT_ERROR,
  GET_STATEMENT_SUCCESS,

  SAVE_STATEMENT,
  SAVE_STATEMENT_ERROR,
  SAVE_STATEMENT_SUCCESS,

  DELETE_STATEMENT,
  DELETE_STATEMENT_ERROR,
  DELETE_STATEMENT_SUCCESS,

} from './constants';

export default {

  async [DELETE_STATEMENT]({ commit }, bankStatementID) {
    try {
      commit(DELETE_STATEMENT);
      const response = await axios({
        url: `${process.env.API_URL}/api/bank-statement/${bankStatementID}`,
        method: 'DELETE',
        headers: auth.getAuthHeader(),
      });
      commit(DELETE_STATEMENT_SUCCESS, response.data);
    } catch (err) {
      commit(DELETE_STATEMENT_ERROR, err);
    }
  },
  async [GET_STATEMENTS]({ commit }, args) {
    try {
      commit(GET_STATEMENTS);
      const response = await axios({
        url: `${process.env.API_URL}/api/syndicates/${args.syndicateID}/bank-statement`,
        method: 'GET',
        headers: auth.getAuthHeader(),
        params: {
          limit: args.limit || localStorage.pageLimit || '25',
          page: args.page || 0,
          sortField: args.sortField || 'date',
          sortDir: args.sortDir || 'DESC',
          filters: args.filters || null,
        },
      });
      commit(GET_STATEMENTS_SUCCESS, response.data);
    } catch (err) {
      commit(GET_STATEMENTS_ERROR, err);
    }
  },
  async [SAVE_STATEMENT]({ commit }, data) {
    try {
      commit(SAVE_STATEMENT);
      let url = `${process.env.API_URL}/api/bank-statement`;
      let method = 'POST';
      const formdata = new FormData();
      formdata.append('syndicateID', data.syndicateID);
      formdata.append('pdf', data.pdf);
      formdata.append('link', data.link);
      formdata.append('date', data.date);
      formdata.append('document_type', data.document_type);
      if (data.bankStatementID) {
        url = `${url}/${data.bankStatementID}`;
        method = 'PUT';
      }
      const response = await axios({
        url,
        method,
        headers: {
          ...auth.getAuthHeader(),
          'Content-Type': 'multipart/form-data',
        },
        data: formdata,
      });
      commit(SAVE_STATEMENT_SUCCESS, response.data);
    } catch (err) {
      commit(SAVE_STATEMENT_ERROR, err);
    }
  },

  async [GET_STATEMENT]({ commit }, bankStatementID) {
    try {
      commit(GET_STATEMENT);
      const response = await axios({
        url: `${process.env.API_URL}/api/bank-statement/${bankStatementID}`,
        method: 'GET',
        headers: auth.getAuthHeader(),
      });
      commit(GET_STATEMENT_SUCCESS, response.data);
    } catch (err) {
      commit(GET_STATEMENT_ERROR, err);
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/BankStatement/actions.js